export const COLOR_LIST = [
  { value: '-', label: '-' },
  { value: 'low silver', label: 'LOW SILVER' },
  { value: 'back', label: 'BACK' },
  { value: 'bed  blue  is', label: 'BED BLUE IS' },
  { value: 'bed  blue two-tone', label: 'BED BLUE TWO-TONE' },
  { value: 'rear  pink m', label: 'REAR PINK M' },
  { value: 'black m', label: 'BLACK M' },
  { value: 'red', label: 'RED' },
  { value: 'yellow is', label: 'YELLOW IS' },
  { value: 'yellow is', label: 'YELLOW IS' },
  { value: 'green', label: 'GREEN' },
  { value: 'ho ', label: 'HO ' },
  { value: 'red', label: 'RED' },
  { value: 'red / black', label: 'RED / BLACK' },
  { value: 'actual vehicle', label: 'actual vehicle' },
  { value: 'alpine white', label: 'ALPINE WHITE' },
  { value: 'aluminium', label: 'ALUMINIUM' },
  { value: 'amethyst  black', label: 'AMETHYST BLACK' },
  { value: 'any', label: 'ANY' },
  { value: 'ash', label: 'ASH' },
  { value: 'ash blue', label: 'ASH BLUE' },
  { value: 'attitude  black', label: 'ATTITUDE BLACK' },
  { value: 'attitude ', label: 'ATTITUDE ' },
  { value: 'aurora  flair  blue', label: 'AURORA FLAIR BLUE' },
  { value: 'aurora  flair  blue  pearl', label: 'AURORA FLAIR BLUE PEARL' },
  { value: 'aurora ', label: 'AURORA ' },
  { value: 'azure gray', label: 'AZURE GRAY' },
  { value: 'bar  gun ', label: 'BAR GUN ' },
  { value: 'beige', label: 'Beige' },
  { value: 'beige 2', label: 'BEIGE 2' },
  { value: 'beige blue', label: 'BEIGE BLUE' },
  { value: 'beige m', label: 'BEIGE M' },
  { value: 'beige two-tone', label: 'BEIGE two-tone' },
  { value: 'bla', label: 'bla' },
  { value: 'black', label: 'Black' },
  { value: 'black  color su', label: 'BLACK COLOR SU' },
  { value: 'black  metallic', label: 'BLACK METALLIC' },
  { value: 'black 2', label: 'BLACK 2' },
  { value: 'black m', label: 'BLACK M' },
  { value: 'black meta', label: 'BLACK META' },
  { value: 'black mica', label: 'BLACK MICA' },
  { value: 'black pearl', label: 'BLACK PEARL' },
  { value: 'black sapphire', label: 'BLACK SAPPHIRE' },
  { value: 'black × silver', label: 'BLACK × SILVER' },
  { value: 'blackish is', label: 'BLACKISH IS' },
  { value: 'blackish ', label: 'BLACKISH ' },
  { value: 'blackish red', label: 'BLACKISH RED' },
  { value: 'blue', label: 'Blue' },
  { value: 'blue  color substitution  have', label: 'BLUE COLOR SUBSTITUTION HAVE' },
  { value: 'blue  metallic', label: 'BLUE METALLIC' },
  { value: 'blue / black', label: 'BLUE / BLACK' },
  { value: 'blue / white', label: 'BLUE / WHITE' },
  { value: 'blue 2', label: 'BLUE 2' },
  { value: 'blue m', label: 'BLUE M' },
  { value: 'bluish green', label: 'BLUISH GREEN' },
  { value: 'bluish silver', label: 'BLUISH SILVER' },
  { value: 'bordeaux', label: 'Bordeaux' },
  { value: 'brilliant  white  is', label: 'BRILLIANT WHITE IS' },
  { value: 'brilliant  white pearl', label: 'BRILLIANT WHITE PEARL' },
  { value: 'brilliant silver', label: 'BRILLIANT SILVER' },
  { value: 'bronze', label: 'BRONZE' },
  { value: 'bronze  mica', label: 'BRONZE MICA' },
  { value: 'brown', label: 'BROWN' },
  { value: 'brown 2 color substitution  have', label: 'BROWN 2 COLOR SUBSTITUTION HAVE' },
  { value: 'burning red', label: 'BURNING RED' },
  { value: 'car  person  blue', label: 'CAR  PERSON  BLUE' },
  { value: 'ceramic m', label: 'CERAMIC M' },
  { value: 'ceres  cheer  blue mica (', label: 'CERES CHEER  BLUE MICA (' },
  { value: 'champagne', label: 'CHAMPAGNE' },
  { value: 'champagne  platinum  metallic', label: 'CHAMPAGNE PLATINUM METALLIC' },
  { value: 'cherry  pearl', label: 'CHERRY PEARL' },
  { value: 'cherry ', label: 'CHERRY ' },
  { value: 'clear  blue', label: 'CLEAR BLUE' },
  { value: 'cobalt  blue  metallic', label: 'COBALT BLUE METALLIC' },
  { value: 'cobalt  blue m', label: 'COBALT BLUE M' },
  { value: 'coffer', label: 'coffer' },
  { value: 'cool  bordeaux  the glass  flakes', label: 'COOL BORDEAUX THE GLASS FLAKES' },
  { value: 'cool  white', label: 'COOL WHITE' },
  { value: 'cream', label: 'CREAM' },
  { value: 'crystal  black  silica', label: 'CRYSTAL BLACK SILICA' },
  { value: 'crystal  white pearl', label: 'CRYSTAL WHITE PEARL' },
  { value: 'crystal  white pearl  mica', label: 'CRYSTAL WHITE PEARL MICA' },
  { value: 'crystal black pearl', label: 'CRYSTAL BLACK PEARL' },
  { value: 'cyan  metallic / black  two', label: 'CYAN METALLIC / BLACK TWO' },
  { value: 'd amethyst  gray', label: 'D AMETHYST GRAY' },
  { value: 'd blue', label: 'D BLUE' },
  { value: 'd brown', label: 'D BROWN' },
  { value: 'd gray', label: 'D GRAY' },
  { value: 'd green', label: 'D GREEN' },
  { value: 'd metal  gray', label: 'D METAL GRAY' },
  { value: 'd purple', label: 'D PURPLE' },
  { value: 'dark  metal  gray', label: 'DARK METAL GRAY' },
  { value: 'dark  metal ', label: 'DARK METAL ' },
  { value: 'dark  red', label: 'DARK RED' },
  { value: 'dark  red  mica ', label: 'DARK RED MICA ' },
  { value: 'dark  red  mica m', label: 'DARK RED MICA M' },
  { value: 'dark  red  mica metallic', label: 'DARK RED MICA METALLIC' },
  { value: 'dark  sherry', label: 'DARK SHERRY' },
  { value: 'dark  sherry  mica m', label: 'DARK SHERRY MICA M' },
  { value: 'dark  violet', label: 'DARK VIOLET' },
  { value: 'dark blue', label: 'DARK BLUE' },
  { value: 'dark blue two-tone', label: 'DARK BLUE two-tone' },
  { value: 'dark brown', label: 'DARK BROWN' },
  { value: 'dark gray', label: 'DARK GRAY' },
  { value: 'dark green', label: 'DARK GREEN' },
  { value: 'dark purple', label: 'DARK PURPLE' },
  { value: 'dark red wine', label: 'DARK RED WINE' },
  { value: 'deep  crystal  blue', label: 'DEEP CRYSTAL BLUE' },
  { value: 'desert  khaki', label: 'DESERT KHAKI' },
  { value: 'diamond black', label: 'DIAMOND BLACK' },
  { value: 'diamond silver', label: 'DIAMOND SILVER' },
  { value: 'e-sxa11g', label: 'E-SXA11G' },
  { value: 'excellent blue', label: 'EXCELLENT BLUE' },
  { value: 'framboise red', label: 'FRAMBOISE RED' },
  { value: 'galaxy  gold', label: 'GALAXY GOLD' },
  { value: 'garnet  red', label: 'GARNET RED' },
  { value: 'gold', label: 'GOLD' },
  { value: 'gold  mica', label: 'GOLD MICA' },
  { value: 'gold 2', label: 'GOLD 2' },
  { value: 'gray', label: 'Gray' },
  { value: 'gray  white', label: 'GRAY WHITE' },
  { value: 'gray 2', label: 'GRAY 2' },
  { value: 'gray m', label: 'GRAY M' },
  { value: 'gray meta', label: 'GRAY META' },
  { value: 'gray metallic', label: 'GRAY METALLIC' },
  { value: 'gray p', label: 'GRAY P' },
  { value: 'green', label: 'Green' },
  { value: 'green 2', label: 'GREEN 2' },
  { value: 'green ii', label: 'GREEN II' },
  { value: 'gris', label: 'GRIS' },
  { value: 'gun m', label: 'GUN M' },
  { value: 'gunmetal', label: 'GUNMETAL' },
  { value: 'inazuma  black', label: 'INAZUMA BLACK' },
  { value: 'jet black', label: 'Jet Black' },
  { value: 'khaki', label: 'KHAKI' },
  { value: 'khaki 2', label: 'KHAKI 2' },
  { value: 'l blue', label: 'L BLUE' },
  { value: 'l green', label: 'L GREEN' },
  { value: 'lavender', label: 'LAVENDER' },
  { value: 'leaf  white', label: 'LEAF WHITE' },
  { value: 'light blue', label: 'LIGHT BLUE' },
  { value: 'light blue  color substitution  have', label: 'LIGHT BLUE COLOR SUBSTITUTION HAVE' },
  { value: 'light blue  mica', label: 'LIGHT BLUE MICA' },
  { value: 'light brown', label: 'LIGHT BROWN' },
  { value: 'light green', label: 'LIGHT GREEN' },
  { value: 'light purple ', label: 'LIGHT PURPLE ' },
  { value: 'lime green', label: 'Lime green' },
  { value: 'maroon', label: 'Maroon' },
  { value: 'metal  stream', label: 'METAL STREAM' },
  { value: 'midnight black', label: 'Midnight Black' },
  { value: 'navy', label: 'NAVY' },
  { value: 'navy blue', label: 'NAVY BLUE' },
  { value: 'night  beige  purple', label: 'NIGHT BEIGE  PURPLE' },
  { value: 'night  pale ', label: 'NIGHT PALE ' },
  { value: 'olive green', label: 'OLIVE GREEN' },
  { value: 'orange', label: 'Orange' },
  { value: 'orange / black', label: 'ORANGE / BLACK' },
  { value: 'orange 2', label: 'ORANGE 2' },
  { value: 'other', label: 'other' },
  { value: 'p white', label: 'P WHITE' },
  { value: 'p white 2', label: 'P WHITE 2' },
  { value: 'pap red', label: 'pap red' },
  { value: 'pearl', label: 'Pearl' },
  { value: 'pearl  crystal  car  in', label: 'PEARL CRYSTAL CAR IN' },
  { value: 'pearl / black', label: 'PEARL / BLACK' },
  { value: 'pearl 2', label: 'PEARL 2' },
  { value: 'pearl ii', label: 'PEARL II' },
  { value: 'pearl mica', label: 'PEARL MICA' },
  { value: 'pearl two-tone', label: 'PEARL two-tone' },
  { value: 'pearl white', label: 'Pearl White' },
  { value: 'pearl white 2', label: 'PEARL WHITE 2' },
  { value: 'pink', label: 'pink' },
  { value: 'platinum  bronze', label: 'PLATINUM BRONZE' },
  { value: 'platinum  white p', label: 'PLATINUM WHITE P' },
  { value: 'platinum  white pearl  my', label: 'PLATINUM WHITE PEARL MY' },
  { value: 'precious  silver', label: 'PRECIOUS SILVER' },
  { value: 'premium  corona  orange', label: 'PREMIUM CORONA ORANGE' },
  { value: 'premium  crystal  red', label: 'PREMIUM CRYSTAL RED' },
  { value: 'premium  silver', label: 'PREMIUM SILVER' },
  { value: 'premium  silver m', label: 'PREMIUM SILVER M' },
  { value: 'premium  silver metallic', label: 'PREMIUM SILVER METALLIC' },
  { value: 'premium  yellow', label: 'PREMIUM YELLOW' },
  { value: 'premium ', label: 'PREMIUM ' },
  { value: 'premium rosso', label: 'PREMIUM ROSSO' },
  { value: 'premium ', label: 'PREMIUM ' },
  { value: 'premium silver', label: 'PREMIUM SILVER' },
  { value: 'pure  black', label: 'PURE BLACK' },
  { value: 'pure white  pearl', label: 'PURE WHITE PEARL' },
  { value: 'purple', label: 'PURPLE' },
  { value: 'purple m', label: 'PURPLE M' },
  { value: 'quartz  blue  pearl', label: 'QUARTZ BLUE PEARL' },
  { value: 'red', label: 'Red' },
  { value: 'red  mica m', label: 'RED MICA M' },
  { value: 'red (p)', label: 'RED (P)' },
  { value: 'red / black', label: 'RED / BLACK' },
  { value: 'red 2', label: 'RED 2' },
  { value: 'red m', label: 'RED M' },
  { value: 'red two-tone', label: 'RED two-tone' },
  { value: 'red white blue', label: 'Red White Blue' },
  { value: 'red wine, dark red', label: 'Red wine, Dark Red' },
  { value: 'red/ black', label: 'RED/ BLACK' },
  { value: 'rose m opal', label: 'ROSE M OPAL' },
  { value: 'sapphire black', label: 'SAPPHIRE BLACK' },
  { value: 'sea green', label: 'Sea Green' },
  { value: 'silky beige', label: 'SILKY BEIGE' },
  { value: 'silky silver m', label: 'SILKY SILVER M' },
  { value: 'silver', label: 'Silver' },
  { value: 'silver  graphite', label: 'SILVER GRAPHITE' },
  { value: 'silver  mica m', label: 'SILVER MICA M' },
  { value: 'silver  mica metallic', label: 'SILVER MICA METALLIC' },
  { value: 'silver 2', label: 'SILVER 2' },
  { value: 'silver m', label: 'SILVER M' },
  { value: 'silver meta', label: 'SILVER META' },
  { value: 'silver metallic', label: 'SILVER METALLIC' },
  { value: 'sonic  silver', label: 'SONIC SILVER' },
  { value: 'specified', label: 'specified' },
  { value: 'specified type', label: 'specified type' },
  { value: 'steel silver', label: 'STEEL SILVER' },
  { value: 'super  black  pearl', label: 'SUPER BLACK PEARL' },
  { value: 'super  platinum  aqua m', label: 'SUPER PLATINUM AQUA M' },
  { value: 'super  white', label: 'SUPER WHITE' },
  { value: 'super  white 2', label: 'SUPER WHITE 2' },
  { value: 'super  white ii', label: 'SUPER WHITE II' },
  { value: 'super-black', label: 'SUPER-BLACK' },
  { value: 'tea', label: 'TEA' },
  { value: 'tera * blue', label: 'TERA * BLUE' },
  { value: 'titanium  gray', label: 'TITANIUM GRAY' },
  { value: 'tone', label: 'tone' },
  { value: 'two-tone', label: 'two-tone' },
  { value: 'via  aqua', label: 'VIA AQUA' },
  { value: 'violet', label: 'Violet' },
  { value: 'white', label: 'White' },
  { value: 'white  color substitution  have', label: 'WHITE COLOR SUBSTITUTION HAVE' },
  { value: 'white kid', label: 'WHITE KID' },
  { value: 'white / blue', label: 'WHITE / BLUE' },
  { value: 'white 2', label: 'WHITE 2' },
  { value: 'white pearl  crystal  car ', label: 'WHITE PEARL CRYSTAL CAR ' },
  { value: 'white perl', label: 'WHITE PERL' },
  { value: 'white two-tone', label: 'WHITE two-tone' },
  { value: 'wine', label: 'WINE' },
  { value: 'wine  2', label: 'WINE 2' },
  { value: 'wine m', label: 'WINE M' },
  { value: 'wine r', label: 'WINE R' },
  { value: 'wine red', label: 'Wine Red' },
  { value: 'wine two tone', label: 'WINE two tone' },
  { value: 'yellow', label: 'Yellow' },
  { value: 'yellow 2', label: 'YELLOW 2' },
  { value: 'yellow ?', label: 'yellow ?' },
  { value: 'zeal  red', label: 'ZEAL RED' },
  { value: 'zmv: super  black p', label: 'ZMV: SUPER BLACK P' },
];
